import { showGameSpeedInfoDialog } from '../ui_popup/showGameSpeedInfoDialog.ts';
import { GameSpeedSettings, RoomSettingConstants } from '@colonist/game-base-types';
import { socket } from '../EntryShared.ts';
import { setElementOnClick } from '../ui_utils/DomUtils.ts';
import { GameModeDataController } from '@colonist/shared-types';
export class UIRoomCenterSettingsSpeedView {
    initGameSpeedSettings() {
        this.speedInput = this.container.querySelector('#room_center_gamespeed_settings_input');
        this.speedRightArrow = this.container.querySelector('#gamespeed_settings_right_arrow');
        this.speedLeftArrow = this.container.querySelector('#gamespeed_settings_left_arrow');
        this.speedDivBody = this.container.querySelector('#gamespeed_settings_body');
        this.speedInfo = this.container.querySelector('#gamespeed_settings_speed_info');
        this.speedSettings = GameSpeedSettings;
        this.speedDefaultSetting = RoomSettingConstants.DEFAULT_GAME_SPEED_SETTING;
        this.speedSocketCommand = (value)=>socket.roomClient.setGameSpeed(value);
        setElementOnClick(this.speedInfo, ()=>UIRoomCenterSettingsSpeedView.clickedSpeedInfo());
    }
    static clickedSpeedInfo() {
        showGameSpeedInfoDialog();
    }
    updateOptions(newRoomState) {
        const gameModeData = GameModeDataController.getModeDataForMode(newRoomState.gameSetting.modeSetting);
        var _gameModeData_allowedGameTimers;
        this.speedOptions = (_gameModeData_allowedGameTimers = gameModeData === null || gameModeData === void 0 ? void 0 : gameModeData.allowedGameTimers) !== null && _gameModeData_allowedGameTimers !== void 0 ? _gameModeData_allowedGameTimers : [];
    }
    constructor(container){
        this.container = container;
        this.initGameSpeedSettings();
        this.speedOptions = [];
    }
}
